import * as changeCase from 'change-case';

import { Box, Button, Paper, Popper } from '@mui/material';

import React from 'react';

import ClickAwayListener from './clickAwayListener';

const noop = () => {};

function DimensionMetricPicker({
  anchorEl,
  pickerType,
  headerName,
  items,
  currentItem,
  onSelect,
  onClose,
}) {
  const popperRef = React.useRef(null);

  return (
    <Popper
      id={anchorEl ? 'dimension-metric-picker' : undefined}
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      placement='bottom'
      modifiers={[
        {
          name: 'flip',
          enabled: true,
          options: {
            altBoundary: true,
            rootBoundary: 'viewport',
            fallbackPlacements: [
              'top-start',
              'top',
              'top-end',
              'bottom-start',
              'bottom-end',
            ],
          },
        },
        {
          name: 'preventOverflow',
          enabled: true,
          options: {
            altAxis: true,
            altBoundary: true,
            tether: false,
            rootBoundary: 'viewport',
          },
        },
      ]}
      sx={{ zIndex: 10 }}
    >
      <ClickAwayListener safeRefs={[popperRef]} onClickAway={onClose}>
        <Paper
          ref={popperRef}
          elevation={6}
          sx={{
            mt: 1,
            maxHeight: 600,
            overflow: 'auto',
            width: 300,
          }}
        >
          <Box p={1}>
            {items.map((item) => (
              <Button
                fullWidth
                key={`dim-met-selection-item-${item?.name || item}`}
                onClick={() => onSelect(pickerType, headerName, item)}
                variant='text'
                sx={{
                  backgroundColor:
                    (currentItem?.name || currentItem) === (item?.name || item)
                      ? '#f5f5f5'
                      : undefined,
                  justifyContent: 'flex-start',
                  my: 0.5,
                  textTransform: 'none',
                  color: 'inherit',
                }}
              >
                {changeCase.sentenceCase(item?.label || item)}
              </Button>
            ))}
          </Box>
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
}

export default DimensionMetricPicker;
